<template>
<form @submit.prevent="submit" autocomplete="off">
    <ui-alert type="error" v-for="e, index in errors" :key="index" :dismissible="false">{{ e }}</ui-alert>

    <fieldset>
        <legend>Adres url</legend>

        <ui-textbox label="Adres url" name="url" type="text" v-model="url" validation-rules="required" :validation-messages="errorMessages" placeholder="Wpisz adres url" @change="changed"></ui-textbox>

    </fieldset>

    <fieldset>
        <legend>Podgląd treści</legend>

        <iframe v-if="iframeUrl" width="100%" height="300px;" style="border: 0;" :src="iframeUrl"></iframe>

    </fieldset>

    <div class="form-actions">
        <ui-button color="primary" :disabled="!url">Wybierz</ui-button>
    </div>
</form>
</template>
<script>
import FormErrors from './../../mixins/FormErrors'
import Utils from './../../services/Utils'
export default {
  mixins: [FormErrors],
  data () {
    return {
      error: [],
      errorMessages: Utils.errorMessages([
        'required',
        'min',
        'numeric',
        'email'
      ]),
      url: '',
      iframeUrl: null
    }
  },
  methods: {
    submit () {
      this.$emit('choose', this.url)
    },
    changed () {
      this.iframeUrl = this.url
    }
  }
}
</script>


// WEBPACK FOOTER //
// UrlPreviewForm.vue?44255f34